



























































































import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { omit } from 'lodash';
import { Form } from '@ss/mtd-vue';
import * as api from '@/api';
import AddRgUser from './components/add-rg-user.vue';
import AddReportCc from './components/add-report-cc.vue';
import * as validators from '@/utils/validator';
import AddRobotGuideModal from './moses/addRobotGuideModal.vue';
import { getCurrentTimezoneOffsetMs } from '@/utils/tool';

interface OptionDef<T = any> {
    value: T;
    label: string;
}

const HourOptions: Array<OptionDef<number>> = [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22].map(hour => {
    return {
        value: hour,
        label: `每天${hour}:00`
    };
});
const baseTime = getCurrentTimezoneOffsetMs();

@Component({
    components: {
        AddRgUser,
        AddReportCc,
        AddRobotGuideModal
    }
})
export default class RgReport extends Vue {
    @State(state => state.cti.permission.rg_report)
    permission: boolean;

    showGuideModal: boolean = false;

    $refs: { emailReportFormRef: Form; xmReportFormRef: Form };

    hourOptions: Array<OptionDef<number>> = HourOptions;

    sendConfig: boolean = false;
    emailNotifForm: any = {
        sendCycle: ['day'],
        sendTime: null,
        sendRole: 'NORMAL',
        sendCc: []
    };
    ruleCustom = {
        sendCycle: [{ validator: validators.validateSendCycle, trigger: 'change' }],
        sendTime: [{ validator: validators.validateSendTime, trigger: 'change' }],
        xmGroupIds: [
            {
                required: true,
                message: '请选择至少一个大象群'
            }
        ]
    };

    enableXmGroupNotif: boolean = false;
    xmReportFormData: Omit<CommonTypes.RgXmGroupNotifSettingDef, 'rgId'> = {
        id: null,
        sendConfig: false,
        sendTime: null,
        xmGroupIds: []
    };
    xmGroupOptions: Array<CommonTypes.XmGroup> = [];
    recentXmGroupOptions: Array<CommonTypes.XmGroup> = [];

    get sendTimeDescPreview() {
        const { sendTime } = this.xmReportFormData;
        return sendTime ? '将在每天' + this.formatTimestampToTime(sendTime) + '点发送群消息' : '';
    }

    get checkedXmGroupOptions() {
        return this.xmGroupOptions.filter(item => this.xmReportFormData.xmGroupIds.indexOf(item.xmGroupId) > -1);
    }
    formatTimestampToTime(date: Date) {
        var hours = date.getHours();
        var minutes = '0' + date.getMinutes();
        return hours + ':' + minutes.slice(-2);
    }

    async setXmReportSwitch(toggle: boolean) {
        if (this.xmReportFormData.id == null) {
            this.xmReportFormData.sendConfig = toggle;
        } else {
            this.xmReportFormData.sendConfig = toggle;

            try {
                await this.submitXmReportSetting(true);
                const message = toggle ? '已开启' : '已关闭';
                this.$mtd.message({ message, type: 'success' });
            } catch (e) {
                if (e && e.name === 'ValidationError') {
                    return;
                }
                this.$mtd.message({ message: e.message || '操作出错，请稍后重试', type: 'error' });
            }
        }
    }

    applyFormData(data: any) {
        this.xmReportFormData.id = data.id;
        this.xmReportFormData.sendConfig = data.sendConfig;
        this.xmReportFormData.sendTime = data.sendTime;
        this.xmReportFormData.xmGroupIds = data.xmGroupIds || [];
    }

    transformAPIResData(data: CommonTypes.RgXmGroupNotifSettingResponse) {
        const hasAlreadySet = data.rgId && data.xmGroups?.length > 0;
        const setting: CommonTypes.RgXmGroupNotifSettingDef = {
            id: hasAlreadySet ? 1 : null,
            rgId: this.rgId,
            sendConfig: data.sendConfig == null ? false : data.sendConfig,
            sendTime: data.sendTime == null ? null : new Date(data.sendTime - baseTime),
            xmGroupIds: data.xmGroups?.map(item => item.xmGroupId) || []
        };
        const xmGroupItems: Array<CommonTypes.XmGroup> = (data.xmGroups || []).map(item => {
            return {
                name: item.xmGroupName,
                xmGroupId: item.xmGroupId,
                avatarUrl: item.xmGroupAvatarUrl,
                xmGroupDesc: item.xmGroupName
            };
        });

        return {
            setting,
            xmGroupItems
        };
    }

    async getRgXmReportSetting() {
        try {
            const res = await api.rgApi.getRgXmReportSetting(this.rgId);
            const { code, data } = res;
            if (code === 200) {
                const { setting, xmGroupItems } = this.transformAPIResData(data);
                this.enableXmGroupNotif = setting.sendConfig;
                this.applyFormData(setting);
                this.xmGroupOptions = this.xmGroupOptions.concat(xmGroupItems);
            } else {
                this.$mtd.message({ message: res.message, type: 'error' });
            }
        } catch (e) {
            console.log(e);
        }
    }

    async showSuccessMsg(isSwitch) {
        // if (this.xmReportFormData.id == null) {
        // this.$mtd.confirm({
        //     title: '设置成功',
        //     type: 'success',
        //     dangerouslyUseHTMLString: true,
        //     message: '预计<span style="color: red">一个工作日后</span>会向群管理员发送消息推送审核，请您提醒群管理员及时审批，否则信息无法发送到对应群组中',
        //     width: '433px'
        // });
        // return;
        // }
        //

        if (!isSwitch) {
            this.showGuideModal = true;
        }
    }

    submittingXmReport = false;
    async saveRgXmReportSetting(payload: Omit<CommonTypes.RgXmGroupNotifSettingDef, 'rgId'>, isSwitch: boolean) {
        this.submittingXmReport = true;
        try {
            const res = await api.rgApi.saveRgXmReportSetting({
                ...omit(payload, ['id']),
                sendTime: this.getMillisecond(payload.sendTime),
                rgId: this.rgId
            });
            const { code } = res;
            if (code === 200) {
                this.showSuccessMsg(isSwitch);
                // NOTE: 这里后端没返回 id 字段，但前端目前依赖该字段区分是否是全新设置
                this.xmReportFormData.id = 1;
            } else {
                this.$mtd.message({ message: res.message, type: 'error' });
            }
        } catch (e) {
            console.log(e);
        }
        this.submittingXmReport = false;
    }
    getMillisecond(date: Date) {
        if (date) {
            const hour = date.getHours();
            const min = date.getMinutes();
            return (hour * 3600 + min * 60) * 1000;
        } else {
            return 0;
        }
    }
    submitXmReportSettingFn() {
        this.submitXmReportSetting();
    }
    submitXmReportSetting(isSwitch = false) {
        this.$refs.xmReportFormRef
            .validate(valid => {
                if (!valid) {
                    const e = new Error('校验出错');
                    e.name = 'ValidationError';
                    throw e;
                }
                return this.saveRgXmReportSetting(this.xmReportFormData, isSwitch);
            })
            .catch(e => {
                throw e;
            });
    }

    async getRecentXmGroupList() {
        const res = await api.rgApi.getRecentXmGroupList();
        if (res.code === 200) {
            // NOTE: 合并已选中的群聊 和 最近群聊，去重后展示出来
            const xmGroupIds = [...this.checkedXmGroupOptions.map(item => item.xmGroupId), ...res.data.items.map(item => item.xmGroupId)];
            this.recentXmGroupOptions = res.data.items;
            this.xmGroupOptions = [...this.checkedXmGroupOptions, ...res.data.items].filter((item, index) => {
                return xmGroupIds.indexOf(item.xmGroupId) === index;
            });
        }
    }

    async searchMyXmGroupList(query: string) {
        if (!query) {
            return;
        }
        const res = await api.rgApi.searchXmGroupByKeyword(query);
        const { code, data } = res;
        if (code === 200 && Array.isArray(data.items)) {
            const xmGroupIds = [...this.checkedXmGroupOptions.map(item => item.xmGroupId), ...data.items.map(item => item.xmGroupId)];
            const computedOptions = [...this.checkedXmGroupOptions, ...data.items].filter((item, index) => {
                return xmGroupIds.indexOf(item.xmGroupId) === index;
            });
            this.xmGroupOptions = computedOptions;
        }
    }

    rgId: number = null;

    async created() {
        this.rgId = parseInt(this.$route.query.rgId as string, 10);

        this.getRgEmailReportSetting();

        await this.getRgXmReportSetting();
        this.getRecentXmGroupList();
    }

    changeReportCC(val) {
        this.emailNotifForm.sendCc = val;
    }

    async switchChange(val) {
        if (!val) {
            const res = await api.rgApi.setRgReport(this.rgId, {
                sendConfig: false,
                sendCycle: ['empty'],
                sendTime: 0,
                sendRole: 'empty',
                sendCc: ['empty']
            });
            const { code } = res;
            if (code === 200) {
                this.$mtd.message({
                    type: 'success',
                    message: '修改成功'
                });
            }
        } else {
            this.emailNotifForm = {
                sendCycle: ['day'],
                sendTime: null,
                sendRole: 'NORMAL',
                sendCc: []
            };
        }
    }
    async getRgEmailReportSetting() {
        const res = await api.rgApi.getRgEmailReportSetting(this.rgId);
        const { code, data } = res;
        if (code === 200) {
            this.sendConfig = data.sendConfig;
            if (this.sendConfig) {
                this.emailNotifForm.sendCycle = data.sendCycle;
                this.emailNotifForm.sendTime = data.sendTime;
                this.emailNotifForm.sendRole = data.sendRole;
                this.emailNotifForm.sendCc = data.sendCc;
            }
        }
    }
    async setRgReport() {
        this.$refs.emailReportFormRef
            .validate(async valid => {
                if (valid) {
                    const params = {
                        sendConfig: this.sendConfig,
                        sendCycle: this.emailNotifForm.sendCycle,
                        sendTime: this.emailNotifForm.sendTime,
                        sendRole: this.emailNotifForm.sendRole,
                        sendCc: this.emailNotifForm.sendCc
                    };
                    const res = await api.rgApi.setRgReport(this.rgId, params);
                    const { code } = res;
                    if (code === 200) {
                        this.$mtd.message({
                            type: 'success',
                            message: '修改成功'
                        });
                    }
                }
            })
            .catch(e => e);
    }
}
